<template>
    <div class="product-wrap page-inner">
        <ShopMenus />

        <div class="inner" v-if="product" :key="product.id">
            <div class="gallery">
                <Slideshow v-if="gallery" :data="gallery" />
            </div>

            <div class="content">
                <header class="product-header">
                    <h2 v-html="product.title.rendered"></h2>
                    <h3 v-if="product.sub_title" v-html="product.sub_title"></h3>
                </header>
                
                <Content>
                    <div v-if="product.excerpt.rendered" v-html="product.excerpt.rendered"></div>
                    <div v-if="product.content.rendered && see_more" v-html="product.content.rendered"></div>
                    <span class="see-more" v-if="product.excerpt.rendered && product.content.rendered && !see_more" @click="see_more = true">Product description +</span>
                    <span class="see-more" v-else-if="product.excerpt.rendered && product.content.rendered && see_more" @click="see_more = false">Product description -</span>
                    <div class="returns-link">
                        <router-link to="/shipping-and-returns/">Returns and exchanges (within 14 days)</router-link><br>
                        <span>♡ Share</span>
                    </div>
                    <div class="select-size">
                        <div class="opts" v-if="product.is_variable">
                            <Select :data="product.available_variations" @selected="changeVariable" :default_text="'Colour options'" />
                        </div>
   
                    </div>
                </Content>

                <footer class="product-footer">
                    <p class="outofstock" v-if="!is_in_stock">Out of stock</p>
                    <p v-else v-html="price_text"></p>
                    <div class="add-to-cart" :class="[{'actived': is_in_stock && product_id !== 0}, {'is-loading': is_add_to_cart}]" @click="addToCart">
                        <span>Add to Cart</span>
                    </div>
                    <div v-if="error_msg" class="error-msg">{{error_msg}}</div>
                </footer>


 

                


            </div>
        </div>
        <List v-if="related_products.length !== 0">
            <Item v-for="(item, index) in related_products" :key="item.id + '-' + index" :item="item" />
        </List>

        <div class="load-more">
            <span v-if="!is_loading && !is_end" @click="getProducts(true)">Show more results +</span>
            <span v-if="is_loading && !is_end">Loading...</span>
        </div>


        <Global class="in-page" />
        <Collection />

    </div>

    
</template>

<script>
import Select from '@/components/ui/Select.vue';
import List from '@/components/ui/List.vue';
import Item from '@/components/ProductItem.vue';

import Content from '@/components/ui/Content.vue';
import ShopMenus from '@/components/ShopMenus.vue';
import Slideshow from '@/components/Slideshow.vue';
import Global from '@/components/Global.vue';
import Collection from '@/components/Collection.vue';

import { EventBus } from '@/events/bus.js';

export default {
    name: 'single-product',

    data () {
        return {
            product: false,
            see_more: false,
            is_loading: false,
            gallery: [],
            price_text: '',
            is_in_stock: false,
            related_products: [],
            is_add_to_cart: false,
            error_msg: false,
            product_id: 0,
            quantity: 1,
            paged: 1,
            per_page: 8,
            is_end: false,
            // numbers: [
            //     {text: '1',},
            //     {text: '2',},
            //     {text: '3',},
            //     {text: '4',},
            //     {text: '5',},
            //     {text: '6',},
            //     {text: '7',},
            //     {text: '8',},
            //     {text: '9',},
            // ]
        }
    },

    components: {
        Content,
        ShopMenus,
        Slideshow,
        Select,
        Global,
        Collection,
        List,
        Item,
    },
    

    watch: {
        '$route.params': {
            handler(params) {
                // console.log(this.$route.name);
                this.fetchData(params);
            },
            immediate: true,
        }
    },

    methods: {
        fetchData(params) {
            this.related_products = [];
            this.gallery = [];
            this.price_text = '';
            this.paged = 1;
            this.products = [];
            this.is_end = false;

            this.$ajax.get(`product?slug=${params.slug}`).then(res => {
                document.title = 'MIMA — ' + res.data[0].title.rendered;

                this.product = res.data[0];
                
                // this.stock_status = this.product.stock_status;

                if (this.product.stock_status === 'outofstock') {
                    this.is_in_stock = false;
                } else {
                    this.is_in_stock = true;
                }

                this.gallery = this.product.gallery;

                // if (this.product.featured_image) {
                //     this.gallery.push({
                //         image: this.product.featured_image.url,
                //         medium_large: this.product.featured_image.medium_large,
                //         alt: '',
                //         caption: '',
                //     });
                // }

                if (this.product.is_variable) {
                    // this.is_in_stock = false;
                    let prices = [];
                    this.product.available_variations.forEach(el => {
                        el.text = el.name;
                        el.value = el.id;
                        prices.push(Number(el.price));
                    });

                    let min = Math.min.apply( Math, prices );
                    let max = Math.max.apply( Math, prices );

                    if (min !== max) {
                        this.price_text = `<span>£${min}–${max}</span>`;
                    } else {
                        this.price_text = `<span>£${min}</span>`;
                    }
                    
                } else {
                    this.product_id = this.product.id.toString();
                    
                    if (this.product.sale_price) {
                        this.price_text = `<s>£${this.product.regular_price}</s><span>£${this.product.sale_price}</span>`;
                    } else {
                        this.price_text = `<span>£${this.product.price}</span>`;
                    }
                }
                this.$store.state.is_loading = false;


                this.getProducts(false);

 

   
            });
        },

        getProducts(is_next = false) {
            if (this.is_end) return;
            this.is_loading = true;
            
            if (!is_next) {
                this.paged = 1;
                this.products = [];
                this.is_end = false;

            } else {
                this.paged ++;
            }


            let api = `get-products/?per_page=${this.per_page}&paged=${this.paged}&product_id=${this.product_id}`
            
            if (this.product.product_cat) {
                
                this.product.product_cat.forEach(cat => {
                    api = api + '&product_cat[]=' + cat.term_id;
                });

                this.$ajax.get(api).then(res => {
                    if (is_next) {
                        res.data.forEach(item => {
                            this.related_products.push(item);
                        });
                    } else {
                        this.related_products = res.data;
                    }
                    
                    this.is_loading = false;
                    this.is_end = (res.data.length < this.per_page);


                }).catch((error) => {
                    // console.log(error)
                    this.is_end = true;

                });
            }
        },

        addToCart() {
            if (!this.is_in_stock || !this.product_id || this.is_add_to_cart) return;
            this.$store.state.is_show_loading = true;
            this.is_add_to_cart = true;
            this.$cart('add-item', { 
                method: 'post',
                data: {
                    product_id: this.product_id,
                    quantity: this.quantity,
                },
            }).then((response) => {
                this.is_add_to_cart = false;
                this.$store.state.is_show_loading = false;

                EventBus.$emit('cart.open', true);
            }).catch(error => {
                console.log(error)
                // this.error_msg = error.response.data.message;
                this.is_add_to_cart = false;
                this.$store.state.is_loading = false;

                setTimeout(() => {
                    this.error_msg = false;
                }, 3000);
            });
        },
        changeQuantity(obj) {
            this.quantity = Number(obj.text);
        },
        changeVariable(obj) {
            console.log(obj);
            this.product_id = obj.id.toString();
            // if (obj.is_in_stock) {

            // } else {
                
            // }
            this.is_in_stock = obj.is_in_stock;

            if (obj.price !== obj.regular_price) {
                this.price_text = `<s>£${obj.regular_price}</s><span>£${obj.price}</span>`;
            } else {
                this.price_text = `<span>£${obj.price}</span>`;
            }

        },
    },
}
</script>
<style lang="scss">


    .product-wrap {
        overflow: hidden;

        .inner {
            display: flex;
            padding: var(--padding-50) 0;
            box-sizing: border-box;
        }

        .gallery {
            width: 50%;
            display: block;
            padding: 0 var(--padding-50) 0 var(--padding);
            box-sizing: border-box;
        }

        .content {
            width: 50%;
            display: grid;
            grid-template-rows: auto 1fr auto;
            grid-template-columns: 100%;
            min-height: 100%;
            padding: 0 var(--padding) 0 var(--padding-50);
            box-sizing: border-box;
            font-size: var(--small-size);

            .ui-enter p, .ui-enter h1, .ui-enter h2, .ui-enter h3, .ui-enter h4, .ui-enter ul, .ui-enter ol {
                margin: 0 0 var(--padding-50) 0;
            }

            .see-more {
                cursor: pointer;
            }

            .returns-link {
                margin: var(--padding-50) 0;
            }
        }

        .product-header {
            margin: 0 0 var(--padding-50);
            font-size: var(--base-size);
        }

        .product-footer {
            padding: var(--padding) 0 0;

            & > p {
                font-size: var(--title-size);

                s {
                    color: var(--gray);
                    display: inline-block;
                    margin-right: .5rem;
                }

                &.outofstock {
                    color: var(--gray);
                }
                
            }

            .add-to-cart {
                margin: var(--padding-25) 0 0;

                span {
                    display: inline-block;
                    font-size: var(--title-size);
                    padding: .3rem 1rem;
                    color: var(--gray);
                    background: var(--light-gray);
                }

                &.actived {
                    span {
                        color: var(--font-color);
                        background: var(--orange);
                        cursor: pointer;
                    }

                    &:hover {
                        span {
                            background: #000;
                            color: white;
                        }
                    }
                }
            }
        }

        .ui-list {
            padding: 0 var(--padding-50);
        }
        .load-more {
            text-align: center;
            padding: 0 var(--padding) var(--padding-x2);
            min-height: 3rem;

            span {
                cursor: pointer;
            }
        }
    }

    @media only screen and (max-width: 767px) {
        .product-wrap {

            .product-header {
                h2 {
                    font-size: var(--large-size);
                }
            } 

            .inner {
                display: block;
                padding: var(--padding-50) 0;
                box-sizing: border-box;
            }

            .gallery {
                width: 100%;
                padding: 0 var(--padding) var(--padding);
            }

            .content {
                width: 100%;
                min-height: unset;
                padding: 0 var(--padding);
                box-sizing: border-box;
                font-size: var(--base-size);

            }


            .product-footer {

                .add-to-cart {
                    margin: var(--padding-25) 0 0;

                    span {
     
                        padding: 1rem 3rem;
   
                    }

                }
            }

            .ui-list {
                padding: 0 var(--padding-50);
            }
            .load-more {
                text-align: center;
                padding: 0 var(--padding) var(--padding-x2);
                min-height: 3rem;

                span {
                    cursor: pointer;
                }
            }
        }
    }
</style>

